import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { defaultMemoize } from 'reselect';

import { makePathMatch } from 'src/app/popsicle/utils';
import * as paths from 'src/app/router/paths';
import type { RedirectedRoute, Route } from 'src/app/router/routes';
import routes from 'src/app/router/routes';
import { getCurrentPathname } from 'src/app/state/selectors';
import type { RootState } from 'src/app/state/store';
import { DOCUMENT_TITLE } from 'src/consts';

import { HeadTitle } from '.';

const makeMapStateToProps = () => {
  const initializePathMatch = defaultMemoize(() => makePathMatch({ routes, paths }));
  const getPathMatch = initializePathMatch();
  const getNormalizedPathName = defaultMemoize((pathName: string) => getPathMatch(pathName)?.path);

  type GetPathsAndTitlesFromRoutes = (routes: (Route | RedirectedRoute)[]) => { [key: string]: string };
  const initializePathAndTitleLookup: GetPathsAndTitlesFromRoutes = defaultMemoize(routes => {
    return routes?.reduce((pathsAndTitles, { path, title }) => {
      pathsAndTitles[path] = title;
      return pathsAndTitles;
    }, {});
  });

  return (state: RootState) => {
    const pathName = getCurrentPathname(state);
    // Changes pathName from /rx/93929/tracking to /rx/:orderId/tracking
    const normalizedPathName = getNormalizedPathName(pathName);
    const pathsAndTitles = initializePathAndTitleLookup(routes);
    // If no corresponding path is found, we show our default title
    const currentPageTitle = pathsAndTitles?.hasOwnProperty(normalizedPathName)
      ? pathsAndTitles[normalizedPathName]
      : DOCUMENT_TITLE;
    return {
      title: currentPageTitle,
    };
  };
};

const connector = connect(makeMapStateToProps());
export type PropsFromRedux = ConnectedProps<typeof connector>;

export const DynamicPageTitle = connector(HeadTitle);
